import { render, staticRenderFns } from "./StaffCheckInPage.vue?vue&type=template&id=1b98f7e0&scoped=true"
import script from "./StaffCheckInPage.vue?vue&type=script&lang=js"
export * from "./StaffCheckInPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b98f7e0",
  null
  
)

export default component.exports